import { normalizeStockCategory, type StockCategory } from "./stockData";

export type SearchResult = { symbol: string; name: string; category?: StockCategory };

export function searchRows(payload: unknown): SearchResult[] {
  const resultRows = (payload as { results?: unknown[] } | null)?.results;
  const rows = Array.isArray(payload) ? payload : Array.isArray(resultRows) ? resultRows : [];
  const parsed: SearchResult[] = [];
  for (const row of rows.slice(0, 7)) {
    const item = row as Record<string, unknown>;
    const symbol = String(item.symbol ?? item.ticker ?? "").toUpperCase();
    if (!symbol) continue;
    const rawName = item.name ?? item.companyName;
    parsed.push({ symbol, name: typeof rawName === "string" && rawName.trim() ? rawName : symbol, category: normalizeStockCategory(item.category ?? item.sector ?? item.assetClass ?? item.type) });
  }
  return parsed;
}
